<template>
  <nav
    class="navbar navbar-expand-lg  fixed-top"
    :class="{ change_color: scrollPosition > 50 }"
  >
    <div class="container px-0">
      <router-link class="nav-link" to="/main/home">
        <img src="../images/footer_logo.png" alt="" />
      </router-link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarText"
        aria-controls="navbarText"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse " id="navbarText">
        <ul class="navbar-nav mr-auto ">
          <li class="nav-item active">
            <router-link class="nav-link" to="/main/home">
              <span>Ana Sayfa</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/main/home">
              <span>Hakkımızda</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/main/home">
              <span>Yardım</span>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/main/home">
              <span>İletişim</span>
            </router-link>
          </li>
        </ul>

        <ul class="navbar-nav select">
          <li class="nav-item">
            <div class="lang-menu">
              <div class="selected-lang ">
                <img src="../images/turkey.png" alt="" />
              </div>
              <ul>
                <li>
                  <img src="../images/turkey.png" alt="" />
                </li>
                <li>
                  <img src="../images/russia.png" alt="" />
                </li>
                <li>
                  <img src="../images/united-kingdom.png" alt="" />
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <div class="currency-menu text-center">
              <div class="selected-currency ">
                TRY
              </div>
              <ul>
                <li>
                  <a class="tr">TRY</a>
                </li>
                <li>
                  <a class="ru">USD</a>
                </li>
                <li>
                  <a class="en">RUB</a>
                </li>
                <li>
                  <a class="en">EUR</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

import util from '../lib/util';

@Component({})
export default class HeaderHome extends Vue {
  data() {
    return {
      scrollPosition: null,

      e2: 'TRY',

      currency: ['USD', 'TRY', 'RUB', 'EUR'],
    };
  }

  updateScroll() {
    this.scrollPosition = window.scrollY;
  }

  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  }
}
</script>

<style scoped>
.navbar {
  background-color: #131734;
}

.change_color {
  background-color: #2b314a91;
}

.nav-item span {
  color: white;
}

.selected-lang,
.selected-currency {
  padding-left: 8px;
  padding-right: 8px;
}

.lang-menu,
.currency-menu {
  width: 100%;
  font-weight: bold;
  position: relative;
  border-radius: 3px;
  margin-left: 1%;
  color: white;
}
.lang-menu,
.currency-menu,
.selected-lang {
  display: flex;
  line-height: 2;
  cursor: pointer;
}
.lang-menu img {
  width: 32px;
  height: 32px;
}
.lang-menu ul {
  display: none;
  background-color: #ffffff0d;
  position: absolute;
  top: 30px;
  -webkit-box-shadow: 0px 1px 10px rgb(0 0 0 / 20%);
  box-shadow: 0px 1px 10px rgb(0 0 0 / 20%);
  width: 40px;
  left: 4px;
  padding-top: 5%;
}
.lang-menu ul li {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-around;
}
.lang-menu ul li:hover {
  background-color: #ffffff0d;
}

.lang-menu ul li a:before {
  content: '';
  display: inline-block;
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-right: 10px;
  background-size: contain;
  background-repeat: no-repeat;
}
.lang-menu:hover ul {
  display: block;
}

.currency-menu .selected-currency:before {
  display: inline-block;
  width: 32px;
  height: 32px;
  background-size: contain;
  background-repeat: no-repeat;
}
.currency-menu ul {
  display: none;
  background-color: #ffffff0d;
  position: absolute;
  top: 30px;
  width: 40px;
  -webkit-box-shadow: 0px 1px 10px rgb(0 0 0 / 20%);
  box-shadow: 0px 1px 10px rgb(0 0 0 / 20%);
  left: 4px;
}
.currency-menu ul li {
  list-style: none;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-around;
}
.currency-menu ul li a {
  text-decoration: none;
  color: #8c9eff;
}
.currency-menu ul li:hover {
  background-color: #ffffff0d;
}
.currency-menu ul li a:before {
  display: inline-block;
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-right: 10px;
  background-size: contain;
  background-repeat: no-repeat;
}

.currency-menu:hover ul {
  display: block;
}

.select {
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  width: 8%;
}

@media (max-width: 768px) {
  .navbar-collapse {
    background-color: white;
    border-radius: 10px;
    padding: 5% 10%;
  }

  .nav-item span {
    color: black;
  }

  .currency-menu {
    color: black;
  }

  .lang-menu ul {
    left: 0;
  }
  .lang-menu ul,
  .currency-menu ul {
    background-color: white;
  }

  .currency-menu ul li a {
    color: black;
  }

  .selected-lang {
    padding-left: 0px;
    padding-right: 0px;
  }
}
</style>
